'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useOption } from '@react-aria/listbox';
import { useRef, useEffect } from 'react';
import { useTrackDisabledState } from '../../contexts/internal/collection/collection.context.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const ListboxOptionInternal = ({ item: a, state: s })=>{
    var c;
    let p = useRef(null), u = null !== (c = a.props) && void 0 !== c ? c : {}, { withThumbnail: b, disabled: f, textValue: d, label: m } = u, _ = _object_without_properties(u, [
        "withThumbnail",
        "disabled",
        "textValue",
        "label"
    ]), { optionProps: w, isFocusVisible: j } = useOption(a, s, p);
    useTrackDisabledState(a.key, f), useEffect(()=>{
        var e;
        null === (e = p.current) || void 0 === e || e.addEventListener('touchend', (e)=>{
            e.preventDefault();
        }, {
            passive: false,
            once: true
        });
    }, []);
    let y = new Set([
        'swan-listbox-option'
    ]);
    return b && y.add('swan-listbox-option-with-thumbnail'), j && y.add('swan-listbox-option-focused'), jsxs(RenderComp, {
        root: "li",
        forwardedRef: p,
        props: _object_spread({}, _, w),
        classNames: y,
        children: [
            jsx("span", {
                className: "swan-listbox-option-content",
                children: a.rendered
            }),
            jsx("span", {
                className: "swan-listbox-option-selected",
                role: "presentation"
            })
        ]
    });
};

export { ListboxOptionInternal };
